import { api } from "..";

export function getUserRoleRequest(config) {
  return api.get(`/v1/user/role`, config);
}
